import React from 'react';
import { Tag } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import './index.less';

interface MallTitleProps {
  title: String;
  count: number;
  cb: () => void;
}
export default function MallTitle(props: MallTitleProps) {
  const { title, count, cb = () => { } } = props;
  return (
    <div className="mall-title">
      <div className="mall-title-left">
        <span className="title-icon" />
        <span>{title}</span>
      </div>
      {count>-1?
      <div className="mall-title-right" onClick={() => { cb() }}>
        <span>查看全部</span>
        {count>0?<Tag className="see-more-tag" bordered={false}>{count}</Tag>:null}
        <RightOutlined
          className="mall-right-icon"
        />
      </div>:null}
    </div>
  );
};
